import { Injectable } from '@angular/core';
import { CustomerBillingCustomerModel } from './customer-billing-customer.model';
import { fiCustomerType } from './customer-type';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { CustomerBillingOtherCustomerModel } from '../customer-billing-other-customer/customer-billing-other-customer.model';
import { ILightWeightObjectCollection } from '@fi-shared/models';

@Injectable()
export class CustomerService {
    constructor(private fiBackend: FiBackendService) {}

    GetCustomer(id) {
        return this.fiBackend.fetchObject(
            'CustomerBilling/CustomerBilling/GetBillingCustomer/{0}'.format(id),
            CustomerBillingCustomerModel,
        );
    }

    GetObjectsForCustomersLocalSearch() {
        return this.fiBackend.fetchData<ILightWeightObjectCollection>(
            'CustomerBilling/CustomerBilling/GetObjectsForBillingCustomersLocalSearch',
        );
    }

    GetCustomersCount(parameterApiModel) {
        return this.fiBackend.fetchDataPost<number>(
            'CustomerBilling/CustomerBilling/GetBillingCustomersCount',
            parameterApiModel,
        );
    }

    GetCustomers(customerParameterApiModel) {
        return this.fiBackend.fetchObjectsPost(
            'CustomerBilling/CustomerBilling/GetBillingCustomers',
            CustomerBillingCustomerModel,
            customerParameterApiModel,
        );
    }

    SaveCustomer(customer) {
        return this.fiBackend.fetchDataPost('CustomerBilling/CustomerBilling/SaveBillingCustomer', customer);
    }

    GetObjectsForCustomerUnitsLocalSearch() {
        return this.fiBackend.fetchData<ILightWeightObjectCollection>(
            'CustomerBilling/CustomerBilling/GetObjectsForBillingCustomerUnitsLocalSearch',
        );
    }

    GetCustomerUnitsCount(parameterApiModel) {
        return this.fiBackend.fetchDataPost<number>(
            'CustomerBilling/CustomerBilling/GetBillingCustomerUnitsCount',
            parameterApiModel,
        );
    }

    GetCustomerUnits(customerUnitParameterApiModel) {
        return this.fiBackend.fetchDataPost<any[]>(
            'CustomerBilling/CustomerBilling/GetBillingCustomerUnits',
            customerUnitParameterApiModel,
        );
    }

    GetCustomerUnit(customerId, id) {
        return this.fiBackend.fetchObject(
            'CustomerBilling/CustomerBilling/GetBillingCustomerUnit/{0}/{1}'.format(customerId, id),
            CustomerBillingCustomerModel,
        );
    }

    SaveCustomerUnit(customer) {
        return this.fiBackend.fetchDataPost('CustomerBilling/CustomerBilling/SaveBillingCustomerUnit', customer);
    }

    GetOtherBillingCustomersCount(customerType) {
        return this.fiBackend.fetchData<number>(
            'CustomerBilling/CustomerBilling/GetOtherBillingCustomersCount/{0}'.format(
                customerType ? fiCustomerType.Other : customerType,
            ),
        );
    }

    GetOtherBillingCustomers(searchParameterModel) {
        return this.fiBackend.fetchObjectsPost(
            'CustomerBilling/CustomerBilling/GetOtherBillingCustomers',
            CustomerBillingCustomerModel,
            searchParameterModel,
        );
    }

    GetOtherBillingCustomer(Id) {
        return this.fiBackend.fetchObject(
            'CustomerBilling/CustomerBilling/GetOtherBillingCustomer/' + Id,
            CustomerBillingOtherCustomerModel,
        );
    }

    SaveOtherBillingCustomer(customer) {
        return this.fiBackend.fetchDataPost('CustomerBilling/CustomerBilling/SaveOtherBillingCustomer', customer);
    }

    GetResellers() {
        return this.fiBackend.fetchObjects(
            'CustomerBilling/CustomerBilling/GetResellers',
            CustomerBillingOtherCustomerModel,
        );
    }

    GetReseller(Id) {
        return this.fiBackend.fetchObject(
            'CustomerBilling/CustomerBilling/GetReseller/' + Id,
            CustomerBillingOtherCustomerModel,
        );
    }

    SaveReseller(reseller) {
        return this.fiBackend.fetchDataPost('CustomerBilling/CustomerBilling/SaveReseller', reseller);
    }

    getShutOffDateClass(customer: CustomerBillingCustomerModel) {
        if (customer.ShutOffDate) return customer.ShutOffDate <= new Date() ? 'red-color' : 'dark-blue-color';
        return '';
    }
}
